// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Bg0s","badges":"styles_badges__o3lA_"};